import { CuratedSet, SoundPackage } from '@bpm-web-app/create-api-sdk';
import { useGetSectionByName } from '@bpm-web-app/swr-hooks';
import { convertCuratedToSeeMoreLayoutProps, convertSoundPackageToSeeMoreLayoutProps, createAppRoutes } from '@bpm-web-app/utils';
import { useRouter } from 'next/router';
import { ClickableGenres } from '../../clickable-genres/clickable-genres';
import { SeeMoreLayout } from '../../see-more-layout/see-more-layout';

export type SectionNamePageParams = {
    sectionName: string;
    location: string
    type: Parameters<typeof createAppRoutes.section>[1];
};

export function SectionNamePacks() {
    const router = useRouter();
    const { sectionName, type, location } = router.query as SectionNamePageParams;
    const { data: sectionData } = useGetSectionByName(sectionName as string, location);

    return (
        <SeeMoreLayout
            contentType={type === 'curated' ? 'curated-set' : 'pack'}
            pageTitle={`${sectionName}`}
            count={sectionData?.items?.length}
            itemBasePath={type === 'curated' ? createAppRoutes.curated : createAppRoutes.packs}
            data={
                sectionData?.items?.map((item) => (type === 'soundPackage' ? convertSoundPackageToSeeMoreLayoutProps(item as SoundPackage, <ClickableGenres genres={(item as SoundPackage).Genre} />) : convertCuratedToSeeMoreLayoutProps(item as CuratedSet))) ||
                []
            }
        />
    );
}
